import Model from "./Model";

export default class CorrectionCriteriaModel extends Model {
  id: number
  maxScore: number
  examModeId: number
  knowledgeId: number

  constructor(correctionCriteria: any, getters:any) {
    super(getters);
    this.id = correctionCriteria.id;
    // 200 as default value if maxScore undefined as it's most common case
    this.maxScore = correctionCriteria.maxScore || 200;
    this.examModeId = correctionCriteria.examModeId;
    this.knowledgeId = correctionCriteria.ltreeKnowledgeByKnowledgeId || correctionCriteria.knowledgeId;
  }

  examMode() {
    return this.getters.examModeById(this.examModeId)
  }

  knowledge() {
    return this.getters.knowledgeById(this.knowledgeId)
  }
}